module.exports = __webpack_public_path__ + "static/b-a-2-after-c5771a2a5ebcf76c4e9ffc2aebb89845.jpg";